export const DELAY_FOR_CLOSING_ACTION_PROGRESS = 5000;
